import React from "react";

// Continuous editorial marquee. Duplicates children for a seamless loop.
export default function Marquee({ children, className = "" }) {
  return (
    <div className={`marquee-fade overflow-hidden ${className}`} data-testid="marquee">
      <div className="flex w-max animate-marquee gap-16 pr-16 hover:[animation-play-state:paused]">
        {children}
        {children}
      </div>
    </div>
  );
}
